
import {
    ActionsUi,
    DrillsUi,
    ListSessionsUi,
    SessionConnectionsUi,
    SessionsExecutionUi,
    WorkoutsUi,
} from "../../pages/page";
import { AuthGuard } from "./auth-guard";

export const ProtectedPages = ({
    'Drills': <AuthGuard protectedPage={<DrillsUi />} />,
    'Workouts': <AuthGuard protectedPage={<WorkoutsUi />} />,
    'Actions': <AuthGuard protectedPage={<ActionsUi />} />,
    'Connection': <AuthGuard protectedPage={<SessionConnectionsUi />} />,
    'ListSessions': <AuthGuard protectedPage={<ListSessionsUi />} />,
    'SessionsExecution': <AuthGuard protectedPage={<SessionsExecutionUi />} />,
});